import React from 'react';

import { Box, Skeleton } from '@mui/material';

const LoadingTableItems = ({ numberOfRows }: { numberOfRows?: number }) => (
  <>
    {[...Array(numberOfRows || 5)].map((_, index) => (
      <Box key={index} sx={skeletonContaineStyle}>
        <Skeleton animation="wave" height={60} />
      </Box>
    ))}
  </>
);

const skeletonContaineStyle = {
  borderBottom: '1px solid #DDDDDD',
  padding: '10px 0px'
};

export default LoadingTableItems;
